import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getScoreExplainablity,
  getAmlsCommonPreventionScoreExplainablity
} from '../../../redux/actions/tmCommon';
import { fetchTypologiesActions } from '../../../redux/actions/common';
import { getAMLSCommonAlertPartyIdentity } from '../../../redux/actions/common';
import ScoreExplainability from './ScoreExplainability';

function mapStateToProps(state) {
  const { scoreExplainability = {}, preventionScoreExplainability = {} } =
    state.amlsTMCommon;
  const { data, error, isLoading } = scoreExplainability;

  return {
    scoreExplainability: data,
    error,
    authentication: state.authentication,
    isLoading: isLoading || preventionScoreExplainability?.isLoading,
    scoreExplainabilityPrevention: preventionScoreExplainability.data,
    unifiedAlerts: state.amlsCommon,
    trmActions: state.amlsCommon.commonTypologyAction
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getScoreExplainablity,
        getAmlsCommonPreventionScoreExplainablity,
        getAMLSCommonAlertPartyIdentity,
        fetchTypologiesActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScoreExplainability);
